import { render } from "./NoReportsContent.vue?vue&type=template&id=1a6b4e66&scoped=true"
import script from "./NoReportsContent.vue?vue&type=script&lang=js"
export * from "./NoReportsContent.vue?vue&type=script&lang=js"

import "./NoReportsContent.vue?vue&type=style&index=0&id=1a6b4e66&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6b4e66"]])

export default __exports__